<template>
  <div>
    <el-dialog
        title="搜索添加机构"
        :visible.sync="dialogVisible"
        :close-on-click-modal=false
        width="30%"
        :append-to-body=true
        :before-close="handleClose">
      <div class="search-box">
        <el-input v-model="input" placeholder="请输入机构名称关键字" size="mini" width="200px"></el-input>
        <el-button type="primary" size="mini" @click="queryLikeOrgName">搜索</el-button>
      </div>
      <el-table
          :data="tableData"
          :empty-text="$t('common.noData')"
          max-height="400"
          style="width: 100%;">
        <el-table-column
            prop="organName"
            label="机构名称">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="danger"
                @click="handleClick(scope.$index, scope.row)">选中</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      tableData: [
        // {
        //   organName: '机构001',
        //   organCode: 'sdfsdfsdfsaaaasdf',
        // }, {
        //   organName: '机构0011111111',
        //   organCode: 'sdfsdfsdfsaasdfsdfsdfaasdf',
        // }
      ],
      dialogVisible:false,
    }
  },
  methods:{
    handleClose(done){
      done();
    },
    handleOpen(){
      this.dialogVisible = true
      this.queryLikeOrgName();
    },
    handleClick(index,item){
      this.$emit('choseOrgan',item);
      this.dialogVisible = false;
    },
    queryLikeOrgName(){
      // let data = {
      //   orgname:this.input
      // }
      this.$api.queryLikeOrgName({orgname:this.input},'get').then(res=>{
        if(res.code == 200){
          let arr = []
          if(res.data && res.data.length>0){
            res.data.forEach((item,index)=>{
              let obj = {}
              obj.organName = item.orgName;
              obj.organCode = item.orgCode;
              arr.push(obj)
            })
            this.tableData = arr;
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-box{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
